import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface RemoveUsersFromDataAlertsParams {
  dataAlertIds: string[];
  userIds: string[];
}

export class RemoveUsersFromDataAlertsRequest extends Request<RemoveUsersFromDataAlertsParams, IResult> {
  constructor(params: RemoveUsersFromDataAlertsParams) {
    super('removeUsersFromDataAlerts', params);
  }
}
